import * as Sentry from '@sentry/vue'

import {
  defineNuxtPlugin,
  useRuntimeConfig,
  useRouter,
} from '#imports'
import { isAuthStore } from '@/stores/authStore'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const config = useRuntimeConfig()
  const isProduction = config.public.APP_ENV === 'production'

  Sentry.init({
    enabled: config.public.SENTRY_ENABLED,
    app: nuxtApp.vueApp,
    debug: !isProduction,
    dsn: config.public.SENTRY_DSN,
    release: config.public.SENTRY_RELEASE,
    environment: config.public.SENTRY_ENVIRONMENT,
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [
      config.public.SENTRY_TRACE_PROPAGATION_TARGET,
    ],
    beforeSend(event) {
      const auth = nuxtApp.vueApp.$nuxt.$pinia.state.value.auth

      // ユーザー情報があればセット
      if (isAuthStore(auth)) {
        const firstName = auth.user?.firstName
        const lastName = auth.user?.lastName
        const username
          = firstName && lastName ? `${firstName} ${lastName}` : undefined

        event.user = {
          ...(event.user ?? {}),
          id: auth.user?.id,
          username,
          segment: 'user',
          company_id: auth.company?.id,
          company_name: auth.company?.name,
        }
      }

      return event
    },
    // トレースをサンプリングする割合
    tracesSampleRate: 0.2,
    // セッションのリプレイをキャプチャする割合
    replaysSessionSampleRate: 0,
    // エラーが発生したセッションのリプレイをキャプチャする割合
    replaysOnErrorSampleRate: isProduction ? 1 : 0,
  })

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetUser: Sentry.setUser,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException,
      sentryCaptureMessage: Sentry.captureMessage,
    },
  }
})
